/**
 * Akcje historii
 *
 * @export
 * @enum {number}
 */
export enum HistoryAction {
  ADD = 'ADD',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  LOGIN = 'LOGIN',
  SEARCH = 'SEARCH',
  SET_STATUS = 'SET_STATUS',
  GET = 'GET'
}

/**
 * Tłumaczenia akcji historii
 *
 * @export
 * @enum {number}
 */
export enum HistoryActionTranslations {
  ADD = 'Dodanie',
  UPDATE = 'Aktualizacja',
  DELETE = 'Usunięcie',
  LOGIN = 'Logownaie',
  SEARCH = 'Wyszukanie',
  SET_STATUS = 'Zmiana statusu',
  GET = 'Pobranie'
}
